import { render, staticRenderFns } from "./ActiveOnly.vue?vue&type=template&id=232a605b&scoped=true&"
import script from "./ActiveOnly.vue?vue&type=script&lang=js&"
export * from "./ActiveOnly.vue?vue&type=script&lang=js&"
import style0 from "./ActiveOnly.vue?vue&type=style&index=0&id=232a605b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232a605b",
  null
  
)

export default component.exports